export default __webpack_public_path__ + "static/media/ArchivesTimesIcon.56554491.svg";